const innovationConfigAggregator = (node) => {
    return {
        html: node.innerHTML,
        widgetConfiguration: {
            ...Array.from(node.attributes)
                .filter((attr) => attr.name.startsWith('data')) // Filter attributes that start with 'data-'
                .reduce((acc, attr) => {
                    let attrName = attr.name.slice(5) // Remove 'data-' from the name
                    if (attrName.startsWith('w-')) {
                        attrName = attrName.slice(2) // Remove '-w-' if it exists
                    }
                    acc[attrName] = attr.value
                    return acc
                }, {})
        }
    }
}

export default innovationConfigAggregator
